import React, { useEffect, useState } from "react";
import Login from "./auth/Login";
import NavBar from "./NavBar";
import useToken from "../utils/useToken";
import { HashRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import { getDepartmentPermissions } from "../utils/api";

const AppBody = () => {
  
  const {token, setToken } = useToken();
  const [departmentPermission, setDepartmentPermission] = useState(false);
  const [chosenDepartment, setChosenDepartment] = useState(null)

  useEffect(() => {
    chosenDepartment !== null && getDepartmentPermissions(setDepartmentPermission, chosenDepartment);
  },[chosenDepartment])

  return (
      <Router>
      {token === null || token === undefined ? (
        <Login setToken={setToken} />
      ) : (
        <>
          <NavBar setChosenDepartment={setChosenDepartment} chosenDepartment={chosenDepartment}/>
          <Routes chosenDepartment={chosenDepartment} departmentPermission={departmentPermission} />
        </>
      )}
    </Router> 
  );
};

export default AppBody;
